module.exports = __webpack_public_path__ + "img/kr-product-final-card2-img4.a1a678d.png";